// import React, { useRef } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import 'common/assets/css/custom-datepicker.css';
// import calenderIcon from 'common/assets/img/Calender.png';
// import { Box, Image } from "@chakra-ui/react";
// import { constant } from "common/constant";

// const CustomDatePicker = (props) => {
//     const { startDate = null, setStartDate,fullWidth, time = false,onBlur = () => {}, minDate, 
//         maxDate,isDisabled = false } = props; 
//     const datePickerRef = useRef(null); 

//     const handleIconClick = () => {
//         if (datePickerRef.current) {
//             datePickerRef.current.setOpen(true); 
//         }
//     };

//     return (
//         <Box 
//         className={`${fullWidth ? 'custom-datepickerFullWidth' : 'custom-datepicker'}`}
//         >
//             <DatePicker
//                 disabled={isDisabled}
//                 className="custom-datepickerInput"
//                 showTimeSelect={time}
//                 showTimeSelectOnly={time}
//                 timeIntervals={15}
//                 onBlur={onBlur}
//                 timeFormat="HH:mm"
//                 dateFormat={time ? "HH:mm" : "dd-MM-yyyy"} 
//                 placeholderText={time ? constant.selectTime : constant.selectDate}
//                 ref={datePickerRef}
//                 minDate={minDate}
//                 maxDate={maxDate}
//                 selected={startDate}
//                 onChange={(date) => setStartDate(date)}
//                 customInput={<input placeholder={constant.selectDate} className="custom-datepickerInput" />}
//             />
//             {!time &&
//                 <Box className="custom-datepicker-calendar-icon" onClick={handleIconClick}>
//                     <Image src={calenderIcon} h={'16px'} w={'16px'} />
//                 </Box>
//             }
//         </Box>
//     );
// }

// export default CustomDatePicker;


import React, { useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'common/assets/css/custom-datepicker.css';
import calenderIcon from 'common/assets/img/Calender.png';
import { Box, Image } from "@chakra-ui/react";
import { constant } from "common/constant";
import {
    isDateOutOfRange,
    parseDateInput,
    blockManualDateInput,
    blockDatePaste
} from "common/utils/dateInputUtils";

const CustomDatePicker = (props) => {
    const {
        startDate = null,
        setStartDate,
        fullWidth,
        time = false,
        onBlur = () => { },
        minDate,
        maxDate,
        placeholder,
        minTime,
        maxTime,
        isDisabled = false
    } = props;

    const datePickerRef = useRef(null);

    const handleIconClick = () => {
        if (datePickerRef.current && !isDisabled) {
            datePickerRef.current.setOpen(true);
        }
    };

    const handleDateChange = useCallback(
        (date) => {
            if (!date) {
                setStartDate(date);
                return;
            }

            const isOutOfRange = isDateOutOfRange(date, minDate, maxDate, { ignoreTime: !time });
            if (isOutOfRange) return;

            setStartDate(date);
        },
        [setStartDate, minDate, maxDate, time]
    );

    const handleRawChange = useCallback(
        (event) => {
            if (time) return;
            if (!minDate && !maxDate) return;

            const parsed = parseDateInput(event?.target?.value);
            if (!parsed) return;

            if (isDateOutOfRange(parsed, minDate, maxDate, { ignoreTime: true })) {
                event.preventDefault();
            }
        },
        [minDate, maxDate, time]
    );

    const renderInPortal = useCallback((container) => {
        if (typeof document === "undefined") return container?.children ?? null;
        return createPortal(container?.children, document.body);
    }, []);

    return (
        <Box
            className={`${fullWidth ? 'custom-datepickerFullWidth' : 'custom-datepicker'}`}
        >
            <DatePicker
                disabled={isDisabled}
                className="custom-datepickerInput"
                showTimeSelect={time}
                showTimeSelectOnly={time}
                timeIntervals={15}
                onBlur={onBlur}
                timeFormat="HH:mm"
                dateFormat={time ? "HH:mm" : "dd/MM/yyyy"}
                placeholderText={placeholder ? placeholder : time ? constant.selectTime : constant.selectDate}
                ref={datePickerRef}
                minDate={minDate}
                maxDate={maxDate}
                minTime={minTime}
                maxTime={maxTime}
                selected={startDate}
                onChange={handleDateChange}
                onChangeRaw={handleRawChange}
                onKeyDown={blockManualDateInput}
                onPaste={blockDatePaste}
                shouldCloseOnSelect={true}
                preventOpenOnFocus={false}
                popperClassName="custom-datepicker-popper"
                popperPlacement="bottom-start"
                popperProps={{ strategy: "fixed" }}
                popperContainer={renderInPortal}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                yearDropdownItemNumber={100}
                scrollableYearDropdown
                customInput={<input placeholder={placeholder ? placeholder : constant.selectDate} className="custom-datepickerInput" />}
            />
            {!time &&
                <Box
                    className="custom-datepicker-calendar-icon"
                    onClick={handleIconClick}
                    style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                >
                    <Image src={calenderIcon} h={'16px'} w={'16px'} />
                </Box>
            }
        </Box>
    );
}

export default CustomDatePicker;
